import * as React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export interface ITileProps {
    children: React.ReactNode;
    navigateTo?: string;
    isExternalLink?: boolean;
    className?: string;
    'aria-label'?: string;
}

export const TileStyles = css`
    box-shadow: var(--elevation-100);
    border-radius: 8px;
    color: var(--text-primary);
    background-color: var(--background-paper-elevation-2);
    transition: all 0.3s ease-in-out;

    &:hover {
        box-shadow: var(--elevation-200);
    }
`;

const TileContainer = styled.div`
    ${TileStyles}
`;

export function Tile({
    children,
    navigateTo,
    isExternalLink,
    className,
    'aria-label': ariaLabel,
}: ITileProps) {
    const innerContent = (
        <TileContainer
            data-cy="tile-container"
            className={`py-13 px-8 ${navigateTo ? 'cursor-pointer' : ''} tile-container ${
                className ?? ''
            }`}
        >
            <div
                className="flex flex-row flex-grow-1 align-center full-height"
                data-cy="tile-content"
            >
                {children}
            </div>
        </TileContainer>
    );

    if (!navigateTo) {
        return (
            <div aria-label={ariaLabel} className="no-text-decoration">
                {innerContent}
            </div>
        );
    }

    if (isExternalLink) {
        return (
            <a
                aria-label={ariaLabel}
                className="no-text-decoration"
                target="_blank"
                rel="noopener noreferrer"
                href={navigateTo}
            >
                {innerContent}
            </a>
        );
    }

    return (
        <Link
            aria-label={ariaLabel}
            className="no-text-decoration"
            to={navigateTo || '#'}
        >
            {innerContent}
        </Link>
    );
}
